var map = {
	"./customer/store.js": "53ad",
	"./material/store.js": "0ad9",
	"./product/store.js": "edea",
	"./project/store.js": "a086",
	"./quotation/store.js": "38a8",
	"./rating/store.js": "0fb8",
	"./report/store.js": "d261",
	"./service/store.js": "901f",
	"./settings/store.js": "dd3c",
	"./ticket/store.js": "ec4d",
	"./user/store.js": "1053"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fcda";